module.exports = __webpack_public_path__ + "thumbnail-035cd47339c14457b6ca58b1c66f1ee9.png";